// @flow
// Action creators for Asset and Job Panel on Map page

// Types
import type { Action } from 'fc-flow-types/redux'

// Constants
import {
  CLEAR_MAP_URL_FROM_JOB_ID,
  PRESELECTED_JOB,
  LOAD_SOIL_PROPS_MAP_DATA,
  SET_SOIL_PROPS_MAP_BLOB_ID,
  PRESELECTED_JOB_SET,
} from './constants'

export const clearMapUrlFromJobId = (): Action<> => ({
  type: CLEAR_MAP_URL_FROM_JOB_ID,
})

export const preselectedJob = (jobId: number): Action<> => ({
  type: PRESELECTED_JOB,
  jobId,
})

export const loadSoilPropsMapData = (fieldId: number): Action<> => ({
  type: LOAD_SOIL_PROPS_MAP_DATA,
  fieldId,
})

export const setSoilPropsMapBlobId = (blobId: number): Action<> => ({
  type: SET_SOIL_PROPS_MAP_BLOB_ID,
  payload: blobId,
})

export const preselectedJobSet = (fieldId: number): Action<> => ({
  type: PRESELECTED_JOB_SET,
  fieldId,
})
